import { useState, useEffect } from "react";
import { useMap } from "react-leaflet";
import { LatLngTuple } from "leaflet";
import "./styles.css";

const FERNANDO_NORONHA_COORDS: LatLngTuple = [-3.85, -32.42];
const PERNAMBUCO_COORDS: LatLngTuple = [-8.28, -35.07];
const MIN_ZOOM = 6;
const ZOOM_THRESHOLD = MIN_ZOOM + 2; // Show button when zoom <= 6

export function FernandoNoronhaControl() {
  const map = useMap();
  const [isAtFernandoNoronha, setIsAtFernandoNoronha] = useState(false);
  const [shouldShow, setShouldShow] = useState(true);

  useEffect(() => {
    const updateVisibility = () => {
      const center = map.getCenter();
      const currentZoom = map.getZoom();

      // Check if we're close to Fernando de Noronha (within ~2 degrees)
      const distanceToFN = Math.abs(center.lat - FERNANDO_NORONHA_COORDS[0]) +
                          Math.abs(center.lng - FERNANDO_NORONHA_COORDS[1]);
      const atFernandoNoronha = distanceToFN < 2;

      setIsAtFernandoNoronha(atFernandoNoronha);

      // Show if at Fernando de Noronha (always) OR if zoom is within threshold
      setShouldShow(atFernandoNoronha || currentZoom <= ZOOM_THRESHOLD);
    };

    // Check initial state
    updateVisibility();

    // Listen to map events
    map.on("moveend", updateVisibility);
    map.on("zoomend", updateVisibility);

    return () => {
      map.off("moveend", updateVisibility);
      map.off("zoomend", updateVisibility);
    };
  }, [map]);

  const handleClick = () => {
    if (isAtFernandoNoronha) {
      map.flyTo(PERNAMBUCO_COORDS, 8, {
        duration: 1.5,
      });
    } else {
      map.flyTo(FERNANDO_NORONHA_COORDS, 12, {
        duration: 1.5,
      });
    }
  };

  if (!shouldShow) return null;

  return (
    <div className="fernando-noronha-floating-container">
      <button
        className="fernando-noronha-button"
        onClick={handleClick}
        title={isAtFernandoNoronha ? "Voltar para Pernambuco" : "Ir para Fernando de Noronha"}
        type="button"
      >
        📍 {isAtFernandoNoronha ? "Pernambuco" : "Fernando de Noronha"}
      </button>
    </div>
  );
}
